import { styled } from "theme/default/styled";

export const SUsersChangeRowInputIcon = styled.button`
  margin-left: 32px;
`;
